// extracted by css-extract-rspack-plugin
export default {"contentfulHeroContainer":"ContentfulHero-module__contentfulHeroContainer__p8NpZ9Z","heroVideo":"ContentfulHero-module__heroVideo__AKHWF5B"};